<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useSidebar } from '@/composables/useSidebar'
import store from '@/store'
import ThemeToggler from '@/components/ThemeToggler.vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Menu as MenuIcon, PanelLeft, LogOut, UserCircle } from 'lucide-vue-next'

const router = useRouter()
const { state, setOpenMobile, toggleSidebar } = useSidebar()

function logout() {
  store.dispatch('logoutUser').then(() => {
    router.push({ name: 'Login' })
  })
}
</script>

<template>
  <header
    class="sticky top-0 z-50 flex h-14 shrink-0 items-center gap-3 border-b border-gray-200 bg-white px-4 dark:border-gray-800 dark:bg-gray-900 md:px-6"
  >
    <button
      type="button"
      class="flex size-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 focus:ring-2 focus:ring-brand-500/30 focus:outline-none dark:text-gray-400 dark:hover:bg-white/5 xl:hidden"
      @click="setOpenMobile(true)"
    >
      <span class="sr-only">Otvoriť menu</span>
      <MenuIcon class="size-6 stroke-[1.5px]" aria-hidden="true" />
    </button>

    <button
      type="button"
      class="flex size-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 focus:ring-2 focus:ring-brand-500/30 focus:outline-none dark:text-gray-400 dark:hover:bg-white/5 hidden xl:flex"
      :aria-expanded="state === 'expanded'"
      @click="toggleSidebar"
    >
      <span class="sr-only">Zbaliť alebo rozbaliť menu</span>
      <PanelLeft class="size-6 stroke-[1.5px]" aria-hidden="true" />
    </button>

    <div class="min-w-0">
      <p class="truncate text-xs text-gray-500 dark:text-gray-400">Bizinix CRM</p>
    </div>

    <div class="ml-auto flex shrink-0 items-center gap-2">
      <ThemeToggler />

      <Menu as="div" class="relative">
        <MenuButton
          class="flex size-9 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:ring-2 focus:ring-brand-500/30 focus:outline-none dark:text-gray-400 dark:hover:bg-white/5"
        >
          <span class="sr-only">Používateľské menu</span>
          <UserCircle class="size-6 stroke-[1.5px]" aria-hidden="true" />
        </MenuButton>
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <MenuItems
            class="absolute right-0 mt-2 w-48 origin-top-right rounded-lg border border-gray-200 bg-white p-1 shadow-theme-lg focus:outline-none dark:border-gray-800 dark:bg-gray-900"
          >
            <MenuItem v-slot="{ active }">
              <router-link
                :to="{ name: 'Profil' }"
                :class="[
                  active ? 'bg-gray-100 dark:bg-white/5' : '',
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300',
                ]"
              >
                <UserCircle
                  class="size-5 shrink-0 stroke-[1.5px] text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                />
                Profil
              </router-link>
            </MenuItem>
            <MenuItem v-slot="{ active }">
              <button
                type="button"
                :class="[
                  active ? 'bg-gray-100 dark:bg-white/5' : '',
                  'flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium text-gray-700 dark:text-gray-300',
                ]"
                @click="logout"
              >
                <LogOut
                  class="size-5 shrink-0 stroke-[1.5px] text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                />
                Odhlásiť sa
              </button>
            </MenuItem>
          </MenuItems>
        </transition>
      </Menu>
    </div>
  </header>
</template>
